const TOKEN_SYNC_TS_KEY = 'tokenUpdatedAt';
const CENTRAL_SETTINGS_CACHE_PREFIX = 'centralSettingsCache:';

const APP_STORAGE_PREFIX = `${process.env.REACT_APP_NAME || 'support-web'}:`;

const PERSISTED_KEYS = [
    'preferredLang',
    'i18nextLng',
    'appLang',
    'darkMode'
];

const snapshotPersistedValues = () => {
    const snapshot = {};
    PERSISTED_KEYS.forEach((key) => {
        const value = localStorage.getItem(key);
        if (value != null) {
            snapshot[key] = value;
        }
    });
    return snapshot;
};

const restorePersistedValues = (snapshot) => {
    Object.entries(snapshot || {}).forEach(([key, value]) => {
        localStorage.setItem(key, value);
    });
};

export const clearSupportSession = ({ preserveToken = false } = {}) => {
    const persistedSnapshot = snapshotPersistedValues();
    const currentToken = preserveToken ? localStorage.getItem('token') : null;

    Object.keys(localStorage).forEach((key) => {
        if (
            key === 'token' ||
            key === TOKEN_SYNC_TS_KEY ||
            PERSISTED_KEYS.includes(key) ||
            key.startsWith(CENTRAL_SETTINGS_CACHE_PREFIX) ||
            key.startsWith(APP_STORAGE_PREFIX) ||
            ['user', 'userCurrentTs', 'tenant', 'isVatNnumberUpdated'].includes(key)
        ) {
            localStorage.removeItem(key);
        }
    });

    sessionStorage.removeItem('token');

    restorePersistedValues(persistedSnapshot);

    if (preserveToken && currentToken) {
        localStorage.setItem('token', currentToken);
    }
};

export const markTokenUpdated = (token) => {
    if (!token) return;
    clearSupportSession({ preserveToken: false });
    localStorage.setItem('token', token);
    localStorage.setItem(TOKEN_SYNC_TS_KEY, Date.now().toString());
};

export const tokenSyncStorageKey = TOKEN_SYNC_TS_KEY;
